export const mapRoleToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfEmployee: item?.employees?.length,
    numOfPermission: item?.permissions?.length,
  }));

  return result;
};

export const roleColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "description", label: "Description", align: "center" },
  { key: "numOfEmployee", label: "Number Of Employee", align: "center" },
  { key: "numOfPermission", label: "Number Of Permission", align: "center" },
];
